import { useEffect, useRef } from 'react'

import { fields } from '../../../../store/constants'
import { CAR_LOOKUP, SIZE_SOURCE, spaced } from '../../../../lib/vehicle'
import { heroCar, heroPrefill, prefillSteps } from '../../../../lib/hero-prefill'

// Arriving from "Book this" on the home page's reg-price fold
// (lib/hero-prefill.js): the plate, its car and the size go in once, after
// the draft has been put back, so the customer starts past the plate. The
// same precedence as ?service= (step-book, 25 Oct 2026): the link is the
// customer's explicit choice and beats a stored draft; on a reload or a Back
// (`linkWins` false) a draft that holds a plate wins, since it carries what
// they changed since. noted(name): the field was filled for them.
export const useHeroPrefill = (form, query, ready, linkWins, noted) => {
  const done = useRef(false)
  useEffect(() => {
    if (done.current || !ready) return
    done.current = true
    const p = heroPrefill(query)
    if (!p || (!linkWins && form.getValues(fields.carRegistration))) return
    const { car, size, sizeSource } = prefillSteps(p, heroCar(p.reg))
    form.setValue(CAR_LOOKUP, car)
    if (size) {
      form.setValue(SIZE_SOURCE, sizeSource)
      form.setValue(fields.carSize, size, { shouldValidate: true })
      noted(fields.carSize)
    }
    form.setValue(fields.carRegistration, spaced(p.reg), { shouldValidate: true })
    noted(fields.carRegistration)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready])
}
